import styled from 'styled-components';

const Logo = styled.div`
	display: flex;
	align-items: center;
	user-select: none;

	h1,
	h2 {
		font-size: 2rem;
		margin-left: 15px;
		font-weight: 600;
	}
`;

export default Logo;
